'use strict'

/**
 * 判定ルール条件式から UI 用対象期間を推定（PeriodKind 未設定時のフォールバック）
 *
 * @param {{ Condition?: string; condition?: string }[] | undefined} judgmentRules
 * @returns {'' | 'monthly' | 'quarter' | 'yearly'}
 */
export const inferUiPeriodKindFromJudgmentRules = (judgmentRules) => {
  if (!Array.isArray(judgmentRules)) return ''
  const text = judgmentRules.map((r) => r?.Condition ?? r?.condition ?? '').join(' ')
  if (/\[(今四半期|前四半期)\./.test(text)) return 'quarter'
  if (/\[(今月|前月)\./.test(text)) return 'monthly'
  if (/\[(今年度|前年度|今年度末月次|前年度末月次)\./.test(text)) return 'yearly'
  return ''
}

/**
 * API PeriodKind を UI 用対象期間（monthly / quarter / yearly）に変換
 *
 * @param {string | null | undefined} periodKind
 * @param {{ Condition?: string; condition?: string }[] | undefined} [judgmentRules]
 * @returns {'' | 'monthly' | 'quarter' | 'yearly'}
 */
export const mapApiPeriodKindToUi = (periodKind, judgmentRules) => {
  const normalized = String(periodKind ?? '')
    .trim()
    .toLowerCase()
  if (normalized === 'year' || normalized === 'yearly') return 'yearly'
  if (normalized === 'quarter' || normalized === 'quarterly') return 'quarter'
  if (normalized === 'monthly') return 'monthly'
  return inferUiPeriodKindFromJudgmentRules(judgmentRules)
}
